export const ReportIdConst = {
  CADDataByMonth: '314',
};
